import { render, staticRenderFns } from "./TagAndSubTagsItem.vue?vue&type=template&id=2edd2863&"
import script from "./TagAndSubTagsItem.vue?vue&type=script&lang=js&"
export * from "./TagAndSubTagsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports